
    import Vue from "vue";
    import {Component} from "vue-property-decorator";
    import {VueInject} from "@/VueIntegration/VueInjectable";
    import {
        TutorialAttemptApi
    } from "@/Api/TutorialAttemptApi";
    import Modal from "../UI/Modal.vue";
    import VueButton from "../UI/VueButton.vue";
    import {Slideshow} from "@/slideshow";
    import {CompletedQuestion} from "@/Core/Interactions";

    @Component({
        components: {
            Modal, VueButton
        }
    })
    export default class ResultsSlide extends Vue {
        @VueInject("TutorialAttemptApi") api: TutorialAttemptApi;
        @VueInject("Slideshow") slideshow: Slideshow;

        questions: CompletedQuestion[] = [];
        selectedQuestion: CompletedQuestion|null = null;

        mounted() {
            this.questions = this.api.getCompletedQuestions().map(x => x);
        }

        openFeedbackModal(q: CompletedQuestion) {
            this.selectedQuestion = q;
        }

        nextSlide() {
            this.slideshow.nextSlide();
        }
    }
